//
//
//
//
//
//
//
//
//
//
//

import copyrightMessage from '@/components/copyrightMessage';
export default {
  name: 'AppMain',
  components: {
    copyrightMessage: copyrightMessage
  },
  computed: {
    cachedViews: function cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key: function key() {
      return this.$route.path;
    }
  },
  created: function created() {
    // console.log(this.cachedViews)
  }
};